var _defs, _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQsDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#ff8400;}.cls-1{opacity:0.1;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21,
    cy: 21,
    r: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.58,10.42a2.45,2.45,0,0,0-1.74-.72H21.36a2.42,2.42,0,0,0-1.71.7L8.4,21.66a2.41,2.41,0,0,0-.7,1.69A2.38,2.38,0,0,0,8.4,25L17,33.6a2.39,2.39,0,0,0,3.38,0L31.58,22.35a2.43,2.43,0,0,0,.71-1.7V12.16A2.44,2.44,0,0,0,31.58,10.42ZM30.29,20.64a.42.42,0,0,1-.12.3L18.92,32.18a.4.4,0,0,1-.56,0L9.81,23.63a.39.39,0,0,1-.11-.28.37.37,0,0,1,.11-.27L21.07,11.83a.4.4,0,0,1,.29-.12h8.48a.46.46,0,0,1,.33.14.46.46,0,0,1,.13.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.8,13.79a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41A1,1,0,0,0,26.8,13.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20,20.32h0a2.57,2.57,0,0,0,1.83-.76h0A2.59,2.59,0,0,0,20,15.14h0a2.59,2.59,0,0,0,0,5.18Zm-.42-3a.58.58,0,0,1,.84,0,.59.59,0,0,1-.42,1h0a.59.59,0,0,1-.42-1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.11,24.41a2.59,2.59,0,0,0,0,3.66,2.54,2.54,0,0,0,1.83.76,2.59,2.59,0,1,0-1.83-4.42Zm2.24,2.25a.59.59,0,1,1-.41-1,.54.54,0,0,1,.41.17A.59.59,0,0,1,20.35,26.66Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.39,21h-9a1,1,0,1,0,0,2h9a1,1,0,0,0,0-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQsDiscount);
export default __webpack_public_path__ + "static/media/qs-discount.4280ef963958ba79411f72d06d70331a.svg";
export { ForwardRef as ReactComponent };